import { render, staticRenderFns } from "./form-text.vue?vue&type=template&id=5658e368&"
import script from "./form-text.vue?vue&type=script&lang=js&"
export * from "./form-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports